import React from 'react';
import { graphql, compose } from 'react-apollo';
import { withStyles } from '@material-ui/core/styles';
import $ from 'jquery';
import { Link } from 'react-router-dom';

import {
    SortingState, FilteringState, IntegratedFiltering, IntegratedSorting,
} from '@devexpress/dx-react-grid';
import classNames from 'classnames';
import * as Icon from '@material-ui/icons';
import {
    Grid,
    VirtualTable, TableHeaderRow, TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import gql from 'graphql-tag';
import GridEx from 'components/form/GridEx';
import ComponentEx from 'components/ComponentEx';
import { Button } from '@material-ui/core';
import c from 'components/form/Components';
import { getTxt, toItalianDateString, toDecimalString, tableMessages } from '../../global/appGlobal';
import LinkToCustomerById from '../../components/LinksToObjectById';
import LinearProgressEx from '../../components/LinearProgressEx';
import { getLabel, getDictionary, DictionaryTypes } from '../../global/dictionaryCache';
import { allRequestsQuery } from '../../modules/request/requestQeries';
import { Menu, MenuItem } from '@material-ui/core';
import CurrencyGridFormatter from 'components/CurrencyGridFormatter';
import { IconButton } from '@material-ui/core';

import * as Icons from '@material-ui/icons';
import RegularCard from '../../components/dashboard/RegularCard';
import * as queries from '../../modules/client/clientQueries';
import Customer_Payment_Edit from '../../modules/client/Client_Payment_Edit';
import { Number } from 'core-js';
import { addDescriptor } from '../../global/entityDescriptors';
import MaterialForm from '../../components/form/MaterialForm';
import { ReportTypes } from '../../global/reporting';

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        margin: theme.spacing.unit * 3,
    },
    button: {
        marginRight: theme.spacing.unit,
    },

    tableHeader: {
        backgroundColor: theme.palette.background.paper,
    },
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& $text, & $icon': {
                color: theme.palette.common.white,
            },
        },
    },
    text: {},
    icon: {},
    totalsRow: {
        backgroundColor: theme.palette.grey['200'],
        fontWeight: 'bold',
    },
    filterForemRoot: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
    },
});

let reports_filter_obj_descr;

const OBG_DESCR_KEY = 'client_balance_filter';

let reportsFilters = {
    start_date_from: null,
    start_date_to: null,
};

const tableColumnExtensions = [
    { columnName: 'total_amount_client', align: 'right' },
    { columnName: 'PaidAmount', align: 'right' },
];


class Client_Balance_Search extends ComponentEx {

    constructor(props) {
        super(props);
        //this.generateReport = this.generateReport.bind(this);
        this.formChanged = this.formChanged.bind(this);
        this.appplyFilters = this.appplyFilters.bind(this);
        reports_filter_obj_descr = {
            from: {
                id: 'from',
                label: getTxt('Transaction Date from'),
                type: 'DATEONLY',
                validators: [],
            },
            to: {
                id: 'to',
                label: getTxt('Transaction Date to'),
                type: 'DATEONLY',
                validators: [],
            },
        };

        reportsFilters = {
            from: null,
            to: null,
        };

        addDescriptor(OBG_DESCR_KEY, reports_filter_obj_descr);

        this.getRowId = row => row.customer_payment_id;
    }

    state = {
        from: null,
        to: null,
        anchorEl: null,
        open: false,
        editId: undefined,
        delDlgOpen: false,
        delId: undefined,
    };

    formSetValues = { func: undefined };

    componentWillUnmount() {
        delete window.refetchCustomerPaymebts;
    }

    formChanged(field, value, type, prevVal) {
        reportsFilters[field] = value;
        const stateVal = {};
        this.state[field] = value;
        this.props.data.refetch({
            customerId: this.props.customerId,
            i: Date.now(),
            from: this.state.from,
            to: this.state.to,
        });
    }


    appplyFilters() {
        this.props.data.refetch({
            i: Date.now(),
            customerId: this.props.customerId,
            from: this.state.from,
            to: this.state.to,
        });
    }

    render() {

        if (this.props.quiet) {
            return (<LinearProgressEx loading={this.props.data.loading} />);
        }

        window.refetchCustomerPaymebts = this.props.data.refetch;

        const columns = [
            { name: 'insurance_company_id', title: getTxt('Compagnia') },
            { name: 'TransactionDate', title: getTxt('Data Incasso') },
            { name: 'ItemType', title: getTxt('Ramo') },
            { name: 'item_type_cd', title: getTxt('Tipo Movimento') },
            { name: 'contract_number', title: getTxt('Numero Polizza') },
            { name: 'total_amount_client', title: getTxt('Premio') },
            { name: 'PaidAmount', title: getTxt('Versamento') },
            { name: 'payment_notes', title: getTxt('Payment Notes') },
        ];

        const { classes } = this.props;

        const resp = this.props.data.customerBalance;

        const items = resp ? JSON.parse(resp) : [];
        const loading = this.props.data.loading;

        const caption = getTxt('Customer Payments');
        const subtitle = getTxt('List of customer payments.');

        let totalPremio = 0;
        let totalVersamento = 0;

        if (items.length > 0) {

            items.forEach((i) => {
                if (i.total_amount_client) {
                    totalPremio += Number.parseFloat(i.total_amount_client);
                }
                if (i.PaidAmount) {
                    totalVersamento += Number.parseFloat(i.PaidAmount);
                }

                if (i.item_type_cd) {
                    if (i.item_type_cd === 'Sostituzione' || i.item_type_cd === 'sostituzione' || i.item_type_cd === 'Sostituita') {
                        i.item_type_cd = 'Sost';
                    } else if (i.item_type_cd === 'Sospensione') {
                        i.item_type_cd = 'Sosp';
                    } else if (i.item_type_cd.length > 3) {
                        i.item_type_cd = i.item_type_cd.substr(0, 3);
                    }
                }
            });

            items.push({
                ID: -1,
                insurance_company_id: '',
                ItemType: '',
                item_type_cd: '',
                TransactionDate: '',
                total_amount_client: totalPremio,
                PaidAmount: totalVersamento,
                State: '',
            });
        }

        return (

            <div className={classes.root}>
                <LinearProgressEx loading={loading} />

                {!this.props.noCaption && <RegularCard

                    headerColor="red"
                    cardTitle={caption}
                    cardSubtitle={subtitle}
                    content={
                        <div>
                            {<Button
                                color="primary"
                                className={classes.button}
                                onClick={() => { this.setState({ editId: 'new' }); }}
                            >{getTxt('Add new Payment')}</Button>}
                        </div>

                    }
                />}
                <div className={classes.filterForemRoot}>
                    <MaterialForm
                        dataSource={reportsFilters}
                        objType={OBG_DESCR_KEY}
                        onChange={this.formChanged}
                        setValues={this.formSetValues}
                    >

                        <c.field f="from" />
                        <c.field f="to" />


                        <GridEx item sm={'auto'} xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    reportsFilters.from = '';
                                    reportsFilters.to = '';


                                    this.formSetValues.func({
                                        from: '',
                                        to: '',
                                        companyId: '',
                                    });
                                    this.setState({
                                        from: '',
                                        to: '',
                                        companyId: '',
                                    });
                                    this.appplyFilters();
                                }}
                            >
                                {getTxt('Reset Filters')}
                            </Button>
                        </GridEx>
                        <GridEx item sm={'auto'} xs={12}>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {

                                    const newWindow = window.open("", "_blank");
                                    newWindow.document.write(getTxt('Generating PDF Report, please wait...'));
                                    this.props.getOneTimeToken({

                                    }, this).then(
                                        (resp_ott) => {

                                            if (resp_ott.data && resp_ott.data.oneTimeTokenMutation && resp_ott.data.oneTimeTokenMutation.token) {

                                                newWindow.location.href = `${window.apiUrl}files/reports?ott=${resp_ott.data.oneTimeTokenMutation.token}&type=${ReportTypes.ClientBalance}&params=${JSON.stringify({ from: this.state.from, to: this.state.to, customerId: this.props.customerId })}`;
                                                newWindow.focus();
                                            }


                                        });
                                }}
                            >
                                {getTxt('Create PDF')}
                            </Button>
                        </GridEx>


                        <GridEx item sm={'auto'} xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {

                                    const newWindow = window.open("", "_blank");
                                    newWindow.document.write(getTxt('Generazione del report XLS, attendere prego...'));
                                    this.props.getOneTimeToken({

                                    }, this).then(
                                        (resp_ott) => {

                                            if (resp_ott.data && resp_ott.data.oneTimeTokenMutation && resp_ott.data.oneTimeTokenMutation.token) {

                                                newWindow.location.href = `${window.apiUrl}files/reports?ott=${resp_ott.data.oneTimeTokenMutation.token}&type=${ReportTypes.ClientBalance}&params=${JSON.stringify({ from: this.state.from, to: this.state.to, customerId: this.props.customerId, xlsx: true })}`;
                                                newWindow.focus();
                                            }


                                        });
                                }}
                            >
                                {getTxt('Genera XLS')}
                            </Button>

                        </GridEx>

                    </MaterialForm>
                </div>
                <Grid

                    rows={items}
                    columns={columns}

                >

                    <CurrencyGridFormatter
                        for={['total_amount_client', 'PaidAmount']}
                    />

                    <FilteringState
                        defaultFilters={[{}]}
                    />

                    <SortingState
                        defaultSorting={[

                        ]}
                    />

                    <IntegratedFiltering
                        columnExtensions={[

                        ]}
                    />
                    <SortingState
                        defaultSorting={[]}
                    />
                    <IntegratedSorting
                        columnExtensions={[
                            // {
                            //     columnName: 'insurance_type_cd',
                            //     compare: (a, b) => {
                            //         const labelA = getLabel(DictionaryTypes.InsuranceType, a);
                            //         const labelB = getLabel(DictionaryTypes.InsuranceType, b);
                            //         if (labelA === labelB) {
                            //             return 0;
                            //         }
                            //         return (labelA < labelB) ? -1 : 1;
                            //     },
                            // },

                        ]}
                    />

                    <VirtualTable
                        messages={tableMessages}
                        columnExtensions={tableColumnExtensions}
                        rowComponent={({ row, ...restProps }) => {
                            if (row.ID === -1) {
                                return (<VirtualTable.Row
                                    className={classes.totalsRow}
                                    {...restProps}
                                />);
                            }
                            return (<VirtualTable.Row {...restProps} />);
                        }}
                        cellComponent={({ row, column, style, ...props }) => {

                            if (column.name === 'State') {
                                return (<VirtualTable.Cell>
                                    {getLabel(DictionaryTypes.InsuranceItemPaymentState, row.State)}
                                </VirtualTable.Cell>);
                            }
                            if (column.name === 'insurance_company_id') {
                                return (<VirtualTable.Cell>
                                    {row.company_name}
                                </VirtualTable.Cell>);
                            }

                            if (column.name === 'TransactionDate') {
                                return (<VirtualTable.Cell>
                                    {toItalianDateString(row.TransactionDate)}
                                </VirtualTable.Cell>);
                            }

                            return <VirtualTable.Cell {...props} />;
                        }}
                    />

                    {/* <TableFilterRow
                        cellComponent={({ column, filter, onFilter, ...props }) => {
                            
                            if (column.name === 'ItemType') {
                                return (
                                    <c.gridColFilter noFilterVal={getTxt('Tutti')} setFilter={onFilter} >
                                        {[{ value: 'Payment', label: 'Payment' }, { value: 'Movimento', label: 'Movimento' }]}
                                    </c.gridColFilter>);
                            }
                           


                            return <TableFilterRow.Cell onFilter={onFilter} filter={filter} {...props} />;
                        }}
                    /> */}

                    <TableHeaderRow />

                </Grid>

                <table className="controTotalTable">
                    <tr>
                        <td>Totale Premi</td>
                        <td>{toDecimalString(totalPremio)}</td>
                    </tr>
                    <tr>
                        <td>Totale Versamenti</td>
                        <td>{toDecimalString(totalVersamento)}</td>
                    </tr>
                    <tr>
                        <td>Differenza</td>
                        <td>{toDecimalString(totalVersamento - totalPremio)}  </td>
                    </tr>


                </table>

            </div >
        );
    }


}


const oneTimeTokenMutation = gql`
        
mutation oneTimeTokenMutation  {
                    oneTimeTokenMutation{
                    token
                }
                }
                `;

export default compose(

    graphql(oneTimeTokenMutation, {
        name: 'getOneTimeToken',
        options: {
            errorPolicy: 'all',
        },
    }),

    graphql(queries.customerBalanceQuery, {

        options: props => (
            {
                variables:
                {
                    i: Date.now(),
                    customerId: props.customerId,
                },
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
            }),


    }),

)(withStyles(styles)(Client_Balance_Search));
